import React from "react";
import { Button, Card, Form, Image, Input, Layout, Row } from 'antd';

import logo from '../assets/images/logo2alt.png';
import { Link } from "react-router-dom";

class Forgot extends React.Component {

    onSend = (values) => {
        console.log(values)
    }

    render = () => {
        return (
            <Layout>
                <Layout.Content className="login-content">
                    <Row className="login-row" justify={'center'} align={'middle'}>
                        <Image src={logo} className="login-image" preview={false} />
                        <Card className="login-card">
                            <Form layout="vertical" onFinish={this.onSend}>
                                <Form.Item name="LOGIN" className="form-input" rules={[{required: true, message: 'Campo obrigatório'}]}>
                                    <Input placeholder="Insira seu e-mail" />
                                </Form.Item>
                                <Form.Item className="form-input">
                                    <Button htmlType="submit" shape="round" type="primary" block className="login-button">Enviar E-mail</Button>
                                    <Link to="/"><Button size="small" type="link" block className="login-link">Voltar</Button></Link>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Row>
                </Layout.Content>
            </Layout>
        )
    }

}

export default Forgot;